import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core';
import axios from 'axios';
import Backdrop from '../../../common/components/UI/Backdrop/Backdrop';
import SettingTitle from '../../../common/components/UI/Title/SettingTitle';
import CustomButton from '../../../common/components/UI/Button/Button';
import SearchInput from '../../../common/components/UI/Search/SearchInput';
import SideBar from '../../../common/components/UI/SideBar/SideBar';
import SimpleDialog from '../../../common/components/UI/Dialog/SimpleDialog';
import SuccesAnimated from '../../../common/components/UI/SuccessAnimated/SuccessAnimated';
import { getFilteredObject } from '../../../services/filterObject';
import Form from './form';
import { TableHeader, TableRow } from '../Table';
import { mapManagerSettings } from '../Table/Table.services';
import * as aux from '../../auxilaries';
import Snackbar from '../../../common/components/UI/Snackbar/Snackbar';
import { currentHttpOptions } from '../../utils';
import { ManagerCreateRequestsActionNames } from '../../Enums';
import { WARNING_TYPES } from '../../constants';

const styles = {
    content: {
        flexGrow: 1,
        margin: '30px 0 0 22px'
    },
    topButtonsContainer: {
        display: 'flex',
    },
    sideBar: {
        minWidth: 840,
        width: 840,
    },
    modalText: {
        width: '100%',
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: 16,
        color: '#3A3A3A'
    },
    topButtons: {
        display: 'flex',
        justifyContent: "space-between"
    }
};

const rootForV1API = `${process.env.REACT_APP_API_DOTNET}/api/v1`;

const parseHyperfindQueries = (hyperfindQueries) => {
    let newHyperfindQueries = [];
    for (let query of hyperfindQueries) {
        newHyperfindQueries.push({
            value: query.id,
            label: query.name,
            desc: query.description,
            visibility: query.visibility
        })
    }
    return newHyperfindQueries;
}

class ManagerDashboardSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displaySpinner: true,
            filteredmanagerList: [],
            hyperFindList: [],
            managerList: [],
            messageSnackbar: '',
            openForm: false,
            openSnackbar: false,
            responseStatus: '',
            responseStatusText: '',
            searchValue: '',
            settingSelected: {},
            showArchiveDialog: false,
            showDeleteDialog: false,
            showResponseDialog: '',
            sideAction: '',
            sortBySelected: '',
            sortOrder: 'Ascending',
            timePeriodRatioOptions: [],
            typeSnackbar: 'success',
            workruleList: [],
        }
        this.init();
    }

    init = async () => {
        const { t } = this.props;
        const options = currentHttpOptions();

        const [
            hyperFindQuery, managerList, settingsForManager, workruleList, timePeriodRatioOptionsList,
        ] = await Promise.all([
            axios.get(`${rootForV1API}/common/GetHyperFindQueries`, options),
            axios.get(`${rootForV1API}/manager/managerSettings/GetSettings?view=1`, options),
            axios.get(`${rootForV1API}/admin/adminSettings/GetSettingsForManager`, options),
            axios.get(`${rootForV1API}/WorkRule/GetWorkRulesList`, options),
            axios.get(`${rootForV1API}/TimePeriodRatio/GetTimePeriodRatioOptions`, options),
        ])

        const defaultWorkRule = [{ label: 'None (Without work rule)', value: -1, workRuleId: -1 }]

        const tempWorkRuleList = defaultWorkRule.concat(workruleList.data.map(rule => {
            return {
                ...rule,
                label: rule.name,
                value: rule.workRuleId,
            }
        }));

        const hyperFindList = parseHyperfindQueries(hyperFindQuery.data);

        const mappedManagerSettings = mapManagerSettings(managerList.data, hyperFindList, t, settingsForManager.data);
        this.setState({
            managerList: mappedManagerSettings,
            filteredmanagerList: mappedManagerSettings,
            hyperFindList,
            settingList: this.formatResponse(settingsForManager.data, 'id'),
            workruleList: tempWorkRuleList,
            displaySpinner: false,
            timePeriodRatioOptions: timePeriodRatioOptionsList.data.map(option => { return { ...option, checked: false } }),
            sortBySelected: '',
            sortOrder: 'Ascending',
        }, () => this.handleSearchFilter());
    }

    formatResponse = (list, key, addNone = false) => {
        let auxList = list.map(item => { return { ...item, value: item[key], label: item.name } })
        addNone && auxList.unshift({ value: null, [key]: null, name: 'None', label: 'None' })
        return auxList
    }

    handleSubmitForm = (form) => {
        const { t } = this.props
        const { sideAction } = this.state;
        this.displaySpinner(true);
        const options = currentHttpOptions()
        if (sideAction === ManagerCreateRequestsActionNames.Edit) {
            return axios.post(process.env.REACT_APP_API_DOTNET + '/api/v1/manager/managerSettings/UpdateSetting', form, options).then(response => {
                if (response.data.pass.length) {
                    this.setState({
                        responseStatus: 'success',
                        showResponseDialog: true,
                        responseStatusText: t('settings.successEdit'),
                        settingSelected: {},
                    })
                }
                else {
                    throw response
                }

                this.closePanelHandler();
                this.init();
            }).catch(err => {
                this.closePanelHandler();
                this.init();
                let message = aux.handleAPIErrors(err)
                this.handleSnackbar('error', message, true);
            }).finally(e => {
                this.displaySpinner(false);
                this.closeResponseDialog();
                this.handleSearchFilter();
            })
        }

        return axios.post(process.env.REACT_APP_API_DOTNET + '/api/v1/manager/managerSettings/AddSetting', form, options).then(response => {
            let responseStatusText;

            if (sideAction === ManagerCreateRequestsActionNames.Duplicate) {
                responseStatusText = t('settings.successDuplicate')
            } else {
                responseStatusText = t('settings.successCreate')
            }
            this.setState({
                responseStatus: 'success',
                showResponseDialog: true,
                responseStatusText: responseStatusText,
                settingSelected: {}
            })

            this.closePanelHandler();
            this.init();
        }).catch(err => {
            this.closePanelHandler();
            this.init();
            let message = aux.handleAPIErrors(err.response)
            this.handleSnackbar('error', message, true);
        }).finally(e => {
            this.displaySpinner(false);
            this.closeResponseDialog();
            this.handleSearchFilter();
        })

    }


    displaySpinner = (displaySpinner) => {
        this.setState({ displaySpinner })
    }

    closePanelHandler = () => {
        this.setState({ openForm: false, settingSelected: {} })
    }

    closeResponseDialog = () => {
        setTimeout(() => {
            this.setState({ showResponseDialog: false })
        }, 3000)
    }

    compareString = (a, b) => {
        var x, y;

        switch (this.state.sortBySelected) {
            case 'warnings':
                x = a.hyperfindSettings?.some(x => x.warnings?.includes(WARNING_TYPES.FAILING_HYPERFIND_EXECUTION)) ? 1 : 0;
                y = b.hyperfindSettings?.some(x => x.warnings?.includes(WARNING_TYPES.FAILING_HYPERFIND_EXECUTION)) ? 1 : 0;
                break;
            default:
                x = a[this.state.sortBySelected]?.toString() || '';
                y = b[this.state.sortBySelected]?.toString() || '';
                break;
        }        

        if (x < y) { return -1; }
        if (x > y) { return 1; }
        return 0;
    }
    

    sortBy = (sortIndex) => {
        var oldSortBy = this.state.sortBySelected;
        this.setState({ sortBySelected: sortIndex },
            () => {
                if (oldSortBy === sortIndex) {
                    const sortOrder = this.state.sortOrder === 'Ascending' ? 'Descending' : 'Ascending'
                    this.setState({ managerList: this.state.managerList.reverse(), sortOrder });
                } else {
                    const sortOrder = this.state.sortOrder === 'Ascending' ? 'Descending' : 'Ascending'
                    this.setState({ managerList: this.state.managerList.sort(this.compareString), sortOrder });
                }
            }
        )
    }

    cancelAction = () => {
        this.setState({
            openForm: false,
            showDeleteDialog: false,
            showArchiveDialog: false,
            sideAction: '',
            spinnerShow: false,
            settingSelected: {},
        })
    }

    rightPanelHandler = (sideAction, selectedItem) => {
        if (sideAction === ManagerCreateRequestsActionNames.Delete) {
            this.setState({
                showDeleteDialog: true,
                sideAction,
                settingSelected: selectedItem,
            })
        } else if (sideAction === ManagerCreateRequestsActionNames.Archive) {
            this.setState({
                showArchiveDialog: true,
                sideAction,
                settingSelected: selectedItem,
            })
        } else {
            this.setState({
                sideAction,
                settingSelected: selectedItem,
                openForm: true
            })
        }
    }
    handleSnackbar = (type, message, openState) => {
        this.setState({
            typeSnackbar: type,
            messageSnackbar: message,
            openSnackbar: openState,
        })
    }

    closeSnackbar = () => {
        setTimeout(() => {
            this.setState({ openSnackbar: false });
        }, 5000)
    }

    dismissItem = async () => {
        const { t } = this.props
        const { settingSelected, sideAction, managerList } = this.state
        const options = currentHttpOptions()
        let message = ''
        this.displaySpinner(true)
        let dismissAction;
        let dismissDialog;
        let successDismissMessage;

        if (sideAction === ManagerCreateRequestsActionNames.Delete) {
            dismissDialog = 'showDeleteDialog'
            successDismissMessage = t('settings.successDelete')
            dismissAction = await axios.delete(process.env.REACT_APP_API_DOTNET + '/api/v1/manager/managerSettings/DeleteSetting/' + settingSelected.aggregateRootId, options)
                .catch(err => {
                    message = aux.handleAPIErrors(err.response)
                    this.handleSnackbar('error', message, true)
                }).finally(() => {
                    this.displaySpinner(false)
                });
        } else if (sideAction === ManagerCreateRequestsActionNames.Archive) {
            dismissDialog = 'showArchiveDialog'
            successDismissMessage = t('settings.successArchived')
            dismissAction = await axios.post(process.env.REACT_APP_API_DOTNET + '/api/v1/manager/managerSettings/ArchiveSetting/' + settingSelected.aggregateRootId, {}, options)
                .catch(err => {
                    message = aux.handleAPIErrors(err.response)
                    this.handleSnackbar('error', message, true)
                }).finally(() => {
                    this.displaySpinner(false)
                });
        }

        let managerListAux = managerList.filter((element) => element.aggregateRootId !== settingSelected.aggregateRootId)

        if (!dismissAction) { //dismissAction is undefined
            this.setState({
                responseStatus: 'error',
                showResponseDialog: true,
                responseStatusText: message,
                settingSelected: {},
                [dismissDialog]: false,
            })
        }
        else if (typeof dismissAction.data.error === 'undefined') {
            this.setState({
                managerList: managerListAux,
                filteredmanagerList: managerListAux,
                responseStatus: 'success',
                showResponseDialog: true,
                responseStatusText: successDismissMessage,
                settingSelected: {},
                [dismissDialog]: false,
            })
        }
        else {
            this.setState({
                responseStatus: 'error',
                showResponseDialog: true,
                responseStatusText: typeof dismissAction.data.error !== 'undefined' ? dismissAction.data.error : dismissAction.data,
                settingSelected: {},
                [dismissDialog]: false,
            })
        }
        this.displaySpinner(false)
        this.closeResponseDialog()
        this.handleSearchFilter()
    }

    handleSearchFilter = (event) => {
        const { searchValue, managerList } = this.state;
        const searchFilter = event === undefined ? searchValue : (event.target.value === undefined) ? searchValue : event.target.value;
        const filteredmanagerList = getFilteredObject(managerList, searchFilter);

        this.setState({
            searchValue: searchFilter,
            filteredmanagerList,
        });
    }

    render() {
        const { classes, t } = this.props;
        const {
            displaySpinner, filteredmanagerList, hyperFindList, managerList, messageSnackbar, openForm,
            openSnackbar, responseStatus, responseStatusText, searchValue, settingList,
            settingSelected, showArchiveDialog, showDeleteDialog, showResponseDialog, sideAction,
            sortBySelected, sortOrder, timePeriodRatioOptions, typeSnackbar, workruleList,
        } = this.state;

        const formTitle = sideAction === ManagerCreateRequestsActionNames.Edit
            ? t('settings.editBid')
            : t('settings.setBid');

        let header = (
            <div
                style={{
                    display: 'flex',
                    justifyContent: "space-between"
                }}
            >
                <div
                    className={classes.topButtonsContainer}
                    style={{
                        display: 'flex',
                        flex: 6,
                    }}
                >
                    <CustomButton
                        size={'medium'}
                        color={'primary'}
                        onClick={() => {
                            this.setState({
                                sideAction: ManagerCreateRequestsActionNames.Create,
                                openForm: true
                            })
                        }}
                    >
                        {t('settings.addNewManager')}
                    </CustomButton>
                </div>
                <div></div>
                <div
                    className={classes.topButtonsContainer}
                    style={{
                        display: 'flex',
                        flex: 6,
                    }}
                >
                    <SearchInput
                        fullWidth={true}
                        value={searchValue}
                        placeholder={t('settings.search')}
                        onChange={this.handleSearchFilter}
                    />
                </div>
            </div>
        )

        let success = showResponseDialog ?
            <SuccesAnimated
                type={responseStatus}
                open={showResponseDialog}
                handleClose={() => { this.setState({ showResponseDialog: false }) }}
            >
                <div className={classes.modalText}>
                    {responseStatusText}
                </div>
            </SuccesAnimated> : '';

        const deleteContentText = t('settings.deleteContent', { configurationType: t('configurationTypes.request').toLowerCase() });
        const archiveContentText = t('settings.archiveContent', { configurationType: t('configurationTypes.request').toLowerCase() });

        return (
            <section>
                <SettingTitle
                    subtitleText={t('settings.appNameManager')}
                    titleText={t('settings.appNameSUBSettings')}
                    reverse={true}
                />
                {header}
                <div className={classes.displayFlex}>
                    <TableHeader
                        sortBy={this.sortBy}
                        sortBySelected={sortBySelected}
                        sortOrder={sortOrder}
                    />
                    {filteredmanagerList.map((bid, index) =>
                        <TableRow
                            key={bid.aggregateRootId}
                            dateFormat={this.props.dateFormat}
                            showRightPanel={this.rightPanelHandler}
                            item={bid}
                            index={index}
                            hyperFindList={hyperFindList}
                        />
                    )}
                </div>
                <SideBar
                    className={classes.sideBar}
                    handleDrawerClose={this.closePanelHandler}
                    open={openForm}
                    title={formTitle}
                    isCloseOnOutsideClick={false}
                >
                    <Form
                        managerList={managerList}
                        hyperFindList={hyperFindList}
                        settingList={settingList}
                        workruleList={workruleList}
                        settingSelected={settingSelected}
                        cancel={this.cancelAction}
                        handleSubmitForm={this.handleSubmitForm}
                        action={sideAction}
                        timePeriodRatioOptions={timePeriodRatioOptions}
                    />
                </SideBar>
                <Backdrop
                    showSpinner={displaySpinner}
                    showback={true}
                />
                <Snackbar
                    type={typeSnackbar}
                    message={messageSnackbar}
                    open={openSnackbar}
                    closeSnackbar={this.closeSnackbar}
                    bodyStyle={{ whiteSpace: 'pre-line' }}
                />
                <SimpleDialog
                    open={showDeleteDialog}
                    title={t('settings.delete')}
                    contentText={deleteContentText}
                    submit={this.dismissItem}
                    cancel={this.cancelAction}
                />
                <SimpleDialog
                    open={showArchiveDialog}
                    title={t('settings.archive')}
                    contentText={archiveContentText}
                    submit={this.dismissItem}
                    cancel={this.cancelAction}
                />
                {success}
            </section>
        )
    }
}

export default withStyles(styles)(withTranslation(['employmentBillboard', 'common'])(ManagerDashboardSettings));
